export default __webpack_public_path__ + "static/media/(6).793acfec.jpg";